import React from "react";
import { withTranslation } from "react-i18next";
import { States } from "src/utils/states";
import { CreditRatingFormInputProps } from "../CRF.types";
import { CRFClassNameGenerator as c, resetCustomErrorMessage, setCustomErrorMessage } from "../CRF.utils";

const AreaInputs = ({
    allStates,
    city,
    isCanada = false,
    onChange,
    postal,
    state,
    t,
}: {
    allStates: States;
    city: string;
    isCanada: boolean;
    state: string;
    postal: any;
} & CreditRatingFormInputProps) => {
    return (
        <div className={c("section")}>
            <div className={c(["subgroup", "thirds"])}>
                <label htmlFor={c(["input", "city"])} className={c("label")}>
                    {t("SoftCreditPull.city")}
                </label>
                <input
                    id={c(["input", "city"])}
                    className={c(["input", "city"])}
                    type="text"
                    name="city"
                    required
                    onChange={onChange("city")}
                    value={city}
                    onInput={resetCustomErrorMessage}
                    onInvalid={setCustomErrorMessage(t("SoftCreditPull.validation.city"))}
                />
            </div>
            <div className={c(["subgroup", "thirds"])}>
                <label htmlFor={c(["input", "state"])} className={c("label")}>
                    {isCanada ? t("SoftCreditPull.province") : t("SoftCreditPull.state")}
                </label>
                <select
                    id={c(["input", "state"])}
                    className={c(["input", "state"])}
                    onChange={onChange("state")}
                    required
                    name="state"
                    defaultValue={state}
                    onInput={resetCustomErrorMessage}
                    onInvalid={setCustomErrorMessage(
                        isCanada ? t("SoftCreditPull.validation.province") : t("SoftCreditPull.validation.state")
                    )}
                >
                    <option value="">
                        {t("SoftCreditPull.dropdownMessage")}{" "}
                        {isCanada ? t("SoftCreditPull.province") : t("SoftCreditPull.state")}
                    </option>
                    {allStates.map((stateOption) => (
                        <option
                            key={stateOption.label + "-area-input-key"}
                            value={stateOption.value}
                            label={stateOption.label}
                        >
                            {stateOption.label}
                        </option>
                    ))}
                </select>
            </div>
            <div className={c(["subgroup", "thirds"])}>
                <label htmlFor={c(["input", "postal"])} className={c("label")}>
                    {isCanada ? t("SoftCreditPull.postal") : t("SoftCreditPull.zip")}
                </label>
                <input
                    id={c(["input", "postal"])}
                    className={c(["input", "postal"])}
                    type="text"
                    name="postal"
                    required
                    onChange={onChange("postal")}
                    value={postal}
                    pattern={isCanada ? "[A-Z][0-9][A-Z] [0-9][A-Z][0-9]" : "[0-9]{5}"}
                    onInput={resetCustomErrorMessage}
                    onInvalid={setCustomErrorMessage(
                        isCanada ? t("SoftCreditPull.validation.postal") : t("SoftCreditPull.validation.zip")
                    )}
                />
            </div>
        </div>
    );
};

export default withTranslation()(AreaInputs);
